<!-- svelte-ignore css-unused-selector -->
<script lang="ts">
    import {NavigationStateStore} from "../services/Store";
    import {get} from "svelte/store";
    import {honestyStatementCompleted} from "../services/NavigationService";
    import {ApplicationData} from "../models/ApplicationData";

    let checkedValue = false;
    export let applicationData: ApplicationData = new ApplicationData();
    let navState = get(NavigationStateStore);
    checkedValue = navState.honestyStatementCompleted;
    const handleClickEvent = () => {
        if (checkedValue == true) {
            honestyStatementCompleted(applicationData);

        }
    }
</script>
<div class="card-no-border">
<h1>Honesty Statement</h1>
<hr />

        <input type="checkbox" bind:checked={checkedValue} disabled="{checkedValue}" on:change={handleClickEvent} />
       I understand that I (or my agent) can ask questions to help clarify any answers I'm unsure about during the application process, so that I can submit an application that is honest and accurate based on my knowledge and beliefs.
<br/>
</div>
<style lang="scss">
  @use "../../component_scss_library/layout" as layout;
  @use "../../component_scss_library/buttons" as buttons;
  @use "../../component_scss_library/forms" as forms;
</style>
